import script from "./LiveSportsContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveSportsContainer.vue?vue&type=script&setup=true&lang=js"

import "./LiveSportsContainer.vue?vue&type=style&index=0&id=5c7adff4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c7adff4"]])

export default __exports__